<template>
  <b-tab
    title="Produtos"
    :active="isTheCurrentTab"
    @click="() => (store.currentTab = 1)"
    :disabled="!isTheCurrentTab && !store.isUpdate"
  >
    <b-row align-v="center">
      <b-col md="10">
        <b-form-group label="Nome" label-for="name">
          <VueSelect
            ref="buscarProduto"
            :filterable="false"
            @input="setProduto"
            :options="produtosFetched"
            :class="{ hasErrors: produtoError, inputFilled: produtoFilled }"
            @search="onSearchProduto"
            v-model="descricao"
          >
            <template slot="no-options"> Informe o produto pelo nome </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>
                  {{ option.codigo }} - {{ option.descricao }}
                  <span
                    id="kitInfo"
                    v-if="option.isKit"
                    :title="getKitInfo(option)"
                    v-b-tooltip.hover.html.right
                  >
                    <InformationOutline :size="14" />
                  </span>
                </div>
                <span
                  v-if="
                    option.preco_atacado > 0 && !option?.preco_lista_cliente
                  "
                  >{{
                    option.preco_atacado
                      ? `QTD: ${option.quantidade} R$: ${numberToReal(
                          option.preco
                        )} Atacado: ${numberToReal(option.preco_atacado)}`
                      : `R$
                  ${numberToReal(option.totalPrice)}`
                  }}</span
                >
                <span
                  v-else-if="
                    option.preco_lista_cliente && option.preco_lista_cliente > 0
                  "
                  >{{
                    option.preco_lista_cliente
                      ? `QTD: ${option.quantidade} R$: ${numberToReal(
                          option.preco_lista_cliente
                        )}`
                      : `R$
                  ${numberToReal(option.totalPrice)}`
                  }}</span
                >
                <span v-else>{{
                  !option.isKit
                    ? `QTD: ${option.quantidade}, R$: ${numberToReal(
                        option.preco
                      )}`
                    : `R$
                  ${numberToReal(option.totalPrice)}`
                }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col class="mt-1">
        <b-dropdown
          id="dropdown-dropright"
          dropright
          variant="primary"
          v-b-tooltip.hover.right
          title="Mudar tipo de filtro"
        >
          <template #button-content>
            <FilterOutline :size="20" class="mt-" />
          </template>
          <b-dropdown-item
            @click="
              () => {
                typeFilter = 1;
              }
            "
            :class="typeFilter === 1 ? 'bg-primary' : ''"
          >
            <p :class="typeFilter === 1 ? 'text-white' : ''">Começando com</p>
          </b-dropdown-item>
          <b-dropdown-item
            @click="
              () => {
                typeFilter = 2;
              }
            "
            :class="typeFilter === 2 ? 'bg-primary' : ''"
          >
            <p :class="typeFilter === 2 ? 'text-white' : ''">Terminando com</p>
          </b-dropdown-item>
          <b-dropdown-item
            @click="
              () => {
                typeFilter = 3;
              }
            "
            :class="typeFilter === 3 ? 'bg-primary' : ''"
          >
            <p :class="typeFilter === 3 ? 'text-white' : ''">Contendo</p>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col class="mt-1">
        <b-button
          variant="primary"
          v-b-tooltip.hover.right
          title="Selecionar lista de preço"
          @click="$bvModal.show('modal-lista-preco')"
        >
          <TagOutline :size="20" class="mr-1" /> Lista
        </b-button>
      </b-col>

      <!-- NOVO: pill com a descrição e botão de remover -->
      <b-col
        class="mt-1"
        v-if="selectedLista && selectedLista.descricao"
        style="margin-bottom: 5px"
      >
        <div class="d-flex align-items-center">
          <span class="badge badge-light px-3 py-2">
            <strong>Lista de preço selecionada:</strong>
            {{ selectedLista.descricao }}
            <button
              type="button"
              class="btn btn-link text-danger p-0 ml-2"
              @click="selectedLista = null"
              title="Remover lista selecionada"
            >
              <CloseCircleOutline :size="18" />
            </button>
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Quantidade" label-for="quantidade">
          <money
            class="form-control"
            ref="quantidade"
            id="quantidade"
            name="quantidade"
            v-model="quantidade"
            v-bind="quantityOptions"
            v-on:keyup.native.enter="handleEnter('preco')"
          />
        </b-form-group>
      </b-col>
      <b-col :cols="windowWidth > 768 ? 0 : 6">
        <b-form-group label="Unitário" label-for="preco">
          <money
            class="form-control"
            ref="preco"
            id="preco"
            name="preco"
            v-model="preco"
            v-bind="priceOptions"
            v-on:keyup.native.enter="handleEnter('desconto')"
          />
        </b-form-group>
      </b-col>
      <b-col :cols="windowWidth > 768 ? 0 : 6">
        <b-form-group label="Desconto" label-for="desconto">
          <b-input-group>
            <money
              v-if="descontoTipo === 'valor'"
              :key="'desconto-valor-' + descontoInputKey"
              class="form-control"
              ref="desconto"
              id="desconto"
              name="desconto"
              v-model="desconto"
              v-bind="configMask"
              v-on:keyup.native.enter="addProduto(produtoSelected)"
            />
            <b-form-input
              v-else
              :key="'desconto-percentual-' + descontoInputKey"
              ref="desconto"
              id="desconto"
              name="desconto"
              type="number"
              min="0"
              max="100"
              step="0.01"
              v-model.number="desconto"
              v-on:keyup.native.enter="addProduto(produtoSelected)"
            />
            <b-input-group-append>
              <b-button variant="light" @click="toggleDescontoTipo">
                {{ descontoTipo === "valor" ? "R$" : "%" }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col :cols="windowWidth > 768 ? 0 : 6">
        <b-form-group label="Total R$" label-for="total">
          <money
            disabled
            class="form-control"
            id="total"
            name="total"
            v-model="total"
            v-bind="priceOptions"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="add">
          <button @click="addProduto(produtoSelected)">
            <Plus
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
              v-if="windowWidth > 768"
            />
            <button
              v-else
              class="btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2"
            >
              Adicionar produto
            </button>
          </button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <TableApp
          item="produto"
          subTitulo=""
          :data="produtos"
          :fields="fields"
          classFilterColumn="nome"
          ref="nome"
        >
          <template slot="customRow" scope="props">
            <span slot="item" class="pl-0 pt-8" v-if="props.field == 'item'">
              <div class="d-flex align-items-center">
                <div class="font-weight-bold text-muted">
                  {{ props.rowData.originalIndex + 1 }} /
                  {{ props.rowData.product.codigo }}
                </div>
              </div>
            </span>
            <span
              slot="nome"
              class="pl-0 pt-8"
              v-if="props.field == 'descricao'"
            >
              <div class="d-flex align-items-center">
                <div class="font-weight-bold text-muted">
                  {{ props.rowData.product.descricao }}
                  <span
                    v-b-tooltip.hover.right="
                      'Item atendeu a regra de preço de atacado'
                    "
                    v-if="props.rowData.product.tipo_atacado"
                  >
                    <InformationOutline :size="14" />
                  </span>
                </div>
              </div>
            </span>
            <span
              slot="quantidade"
              class="pl-0 pt-8"
              v-if="props.field == 'quantidade'"
            >
              <div class="d-flex align-items-center">
                <div class="font-weight-bold text-muted">
                  {{ numberToReal(props.rowData.quantity, "quantidade") }}
                </div>
              </div>
            </span>
            <span slot="preco" class="pl-0 pt-8" v-if="props.field == 'preco'">
              <div class="d-flex align-items-center">
                <div class="font-weight-bold text-muted">
                  {{ numberToReal(props.rowData.price, "preco") }}
                </div>
              </div>
            </span>
            <span
              slot="desconto"
              v-if="props.field == 'desconto'"
              class="text-dark-75 font-weight-bolder d-block font-size-lg"
            >
              R$
              {{ numberToReal(props.rowData.discount, 2) }}
            </span>
            <span
              slot="total"
              v-if="props.field == 'total'"
              class="text-dark-75 font-weight-bolder d-block font-size-lg"
            >
              R$
              {{
                numberToReal(
                  props.rowData.quantity * props.rowData.price -
                    props.rowData.discount,
                  "preco"
                )
              }}
            </span>
            <span slot="actions" v-if="props.field == 'actions'">
              <div class="row-actions" style="text-align: right !important">
                <span
                  style="overflow: visible; position: relative; width: 130px"
                >
                  <div class="action-buttons">
                    <button
                      @click="
                        openModalProduto(
                          props.rowData,
                          props.rowData.currentIndex
                        )
                      "
                      class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                    >
                      <Pencil :size="16" title="Editar" />
                    </button>
                    <button
                      @click="
                        handleDeleteProduto(
                          props.rowData,
                          props.rowData.currentIndex
                        )
                      "
                      class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                    >
                      <TrashCanIcon :size="16" />
                    </button>
                  </div>
                </span>
              </div>
            </span>
          </template>
        </TableApp>
        <b-row v-if="produtos.length > 0">
          <b-col></b-col>
          <b-col></b-col>
          <b-col
            ><span class="text-primary font-weight-bolder">Total Itens:</span>
            {{
              produtos.reduce((acc, produto) => acc + produto.quantity, 0)
            }}</b-col
          >
          <b-col
            ><span class="text-primary font-weight-bolder">Total R$:</span
            >{{
              numberToReal(
                produtos.reduce((acc, produto) => acc + produto.totalPrice, 0),
                "preco"
              )
            }}</b-col
          >
        </b-row>
        <ModalProduto
          :close="closeModalProduto"
          :changeProduto="saveEditProduto"
          :produto="produtoToEdit"
          :open="modalProdutoIsOpen"
          v-if="modalProdutoIsOpen"
        />
      </b-col>
    </b-row>

    <b-modal
      id="modal-lista-preco"
      title="Selecionar lista de preço"
      hide-footer
    >
      <b-form-group label="Lista de Preço">
        <VueSelect
          ref="pedido"
          :filterable="false"
          :options="listaDePrecos"
          v-model="selectedLista"
          @search="onSearchLista"
        >
          <template slot="no-options">Busque pela descrição</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.descricao }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.descricao }}
            </div>
          </template>
        </VueSelect>
      </b-form-group>

      <div class="d-flex justify-content-between">
        <b-button
          variant="danger"
          @click="
            selectedLista = null;
            $bvModal.hide('modal-lista-preco');
          "
        >
          Cancelar
        </b-button>
        <b-button variant="primary" @click="$bvModal.hide('modal-lista-preco')">
          Aplicar
        </b-button>
      </div>
    </b-modal>
    <VariacaoProdutoModal
      :addProduto="addProdutoVariacao"
      :produto="produtoSelected"
      :preco="preco"
      :compra="false"
      @onAddProduto="onAddProdutoFromVariacao"
    />
    <LoteProdutoModal
      :addProduto="addProdutoLote"
      :produto="produtoSelected"
      :preco="preco"
      :atualizarLotes="atualizarLotes"
      @onAddProduto="onAddProdutoFromLote"
    />
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import { Money } from "v-money";
import {
  MONEY as settingMoney,
  priceOptions,
  quantityOptions,
} from "@/modules/Application";
import "vue-select/dist/vue-select.css";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TableApp from "../../../../components/Table/Table3.vue";
import ModalProduto from "./ModalProduto.vue";
import { validationMixin } from "vuelidate";
import ProdutoData, { ProdutoDataRequired } from "../ProdutoData";
import {
  SistemaMixin,
  ValidacaoMixin,
  FormatMixin,
} from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeOrcamento";
import FilterOutline from "vue-material-design-icons/Filter";
import VariacaoProdutoModal from "@/components/VariacaoProdutoModal";
import LoteProdutoModal from "@/components/LoteProdutoModal";
import TagOutline from "vue-material-design-icons/TagOutline.vue";
import CloseCircleOutline from "vue-material-design-icons/CloseCircleOutline.vue";

export default {
  name: "app-orcamento-form-ProdutoTab",
  components: {
    VueSelect,
    ModalProduto,
    TableApp,
    Pencil,
    Plus,
    TrashCanIcon,
    Money,
    FilterOutline,
    InformationOutline,
    VariacaoProdutoModal,
    LoteProdutoModal,
    TagOutline,
    CloseCircleOutline,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      configMask: settingMoney,
      priceOptions,
      quantityOptions,
      typeFilter: 3,
      windowWidth: window.innerWidth,
      fields: [
        {
          label: "Item/Cód",
          field: "item",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Nome",
          field: "descricao",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Qtd",
          field: "quantidade",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Unitário",
          field: "preco",
          sortable: false,
          slot: true,
          width: "10%",
        },
        {
          label: "Desconto",
          field: "desconto",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "Total",
          field: "total",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
      form: {},
      descricao: "",
      quantidade: 1,
      preco: 0,
      desconto: 0,
      descontoTipo: "valor",
      descontoInputKey: 0,
      total: 0,
      fromSelect: false,
      produtoSelected: null,
      estoqueProduto: 0,
      produtosFetched: [],
      produtos: [],
      produtoToEdit: null,
      modalProdutoIsOpen: false,
      dataSendToApi: {},
      produtoError: false,
      produtoFilled: false,
      atualizarLotes: 0,
      selectedLista: null,
      listaDePrecos: [],
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, FormatMixin],
  validations: {
    form: ProdutoDataRequired,
  },
  watch: {
    form(newValue) {
      this.store.formProduto = newValue;
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 2 && oldValue < newValue) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toast.error("Necessario incluir um produto");
          this.produtoError = true;
          this.store.currentTab = oldValue;
          return;
        }
      }
    },
    preco(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.updateTotalProduto();
      }
    },
    quantidade(newValue, oldValue) {
      if (oldValue !== newValue) {
        const isAtacado =
          newValue >= this.produtoSelected.quantidade_atacado &&
          this.produtoSelected.preco_atacado > 0 &&
          this.store.formCliente.tipo_atacado;

        this.preco = isAtacado
          ? this.formatNumberToFloat(this.produtoSelected.preco_atacado)
          : this.produtoSelected.preco;

        this.updateTotalProduto();
        this.produtoSelected.total = this.total;
        this.produtoSelected.tipo_atacado = isAtacado;
        this.produtoSelected.quantidade = newValue;
      }
    },
    desconto(newValue, oldValue) {
      if (oldValue !== newValue && !isNaN(newValue) && newValue !== "") {
        this.updateTotalProduto();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    ...mapActions(["setLoading"]),
    onSearchLista(search, loading) {
      loading(true);
      this.searchLista(loading, search, this);
    },
    searchLista: _.debounce(async (loading, search, vm) => {
      vm.listaDePrecos = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/produtos/get-lista-preco-geral", {
        descricao: search,
      });
      vm.listaDePrecos = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    handleEnter(ref) {
      if (this.fromSelect) {
        this.fromSelect = false;
        return;
      }
      if (!this.$refs[ref]) return;
      this.$refs[ref].$el.focus();

      let inputEl = this.$refs[ref].$el;

      setTimeout(() => {
        inputEl.select();
      }, 100);
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    toggleDescontoTipo() {
      this.descontoTipo =
        this.descontoTipo === "valor" ? "percentual" : "valor";
      this.desconto = 0;
      this.updateTotalProduto();
      this.descontoInputKey++;
    },
    getDescontoProdutoEmReais() {
      const desconto = parseFloat(this.desconto) || 0;

      if (this.descontoTipo === "percentual") {
        return this.roundTo2Digits((this.quantidade * this.preco * desconto) / 100);
      }

      return this.roundTo2Digits(desconto);
    },
    updateTotalProduto() {
      const subtotal = this.quantidade * this.preco;
      this.total = this.roundTo2Digits(subtotal - this.getDescontoProdutoEmReais());
    },
    async addProduto(produto, isKit) {
      if (_.isEmpty(produto)) return;

      if (produto.variavel && !produto.combinacao) {
        this.$toast.warning("Produto sem variação informada!");
        return;
      }

      if (
        !isKit &&
        this.reservaCondicionalUltrapassada(
          produto,
          this.quantidade,
          this.produtos
        )
      ) {
        return false;
      }

      const descontoEmReais = this.getDescontoProdutoEmReais();
      const produtoFormatted = !isKit
        ? {
            ...produto,
            preco: this.preco,
            quantidade: this.quantidade,
            desconto: descontoEmReais,
            total: this.total,
          }
        : { ...produto };
      this.produtos = [
        ...this.produtos,
        !isKit
          ? {
              product: produtoFormatted,
              price: this.preco,
              quantity: this.quantidade,
              totalPrice: this.total,
              discount: descontoEmReais,
              active: true,
              currentIndex: this.produtos.length,
              ...(produto.variavel && { combinacao: produto.combinacao }),
            }
          : {
              ...produto,
              product: { ...produto },
              ...(produto.variavel && { combinacao: produto.combinacao }),
            },
      ];

      const subtotal = this.produtos.reduce(
        (acc, produto) =>
          acc + (produto.quantity * produto.price - produto.discount),
        0
      );
      this.form = {
        produtos: [...this.produtos],
        subtotal,
      };

      this.clearFields();
      this.store.formFaturamento.pagamentos = [];
      if (this.store.formFaturamento.forma_pagamento.descricao === "Nenhum") {
        this.store.formFaturamento.pagamentos[0].valor =
          this.store.formImpostos.totalNFE;
      }

      this.produtoError = false;
      this.$nextTick(() => {
        this.$refs.buscarProduto.$refs.search.focus();
      });
    },
    clearFields() {
      this.descricao = "";
      this.estoqueProduto = 0;
      this.quantidade = 1;
      this.preco = 0;
      this.total = 0;
      this.desconto = 0;
      this.produtoSelected = null;
      this.produtoFilled = false;
    },
    addProdutoVariacao(produto) {
      // Função wrapper para o modal de variação
      // Garante que a descrição inclui a variação antes de adicionar
      if (produto?.combinacao) {
        const descricaoBase = this.produtoSelected?.descricao || produto.descricao;
        
        // Constrói a string da combinação a partir do objeto
        const combinacaoString = [];
        for (const key in produto.combinacao) {
          if (key !== 'quantidade' && produto.combinacao[key]) {
            combinacaoString.push(produto.combinacao[key]);
          }
        }
        
        if (combinacaoString.length > 0) {
          produto.descricao = `${descricaoBase} - ${combinacaoString.join('/')}`;
        }
      }
      this.addProduto(produto);
    },
    addProdutoLote(produto) {
      // Função wrapper para o modal de lote
      // Garante que a descrição inclui o lote antes de adicionar
      if (produto?.lote_baixa) {
        const descricaoBase = this.produtoSelected?.descricao || produto.descricao;
        const lote = produto.lote_baixa;
        produto.descricao = `${descricaoBase} - Nº do Lote: ${lote.numero_lote} / Dt Validade: ${this.formatDate(lote.data_validade)}`;
      }
      this.addProduto(produto);
    },
    onAddProdutoFromVariacao({ newPreco, newQuantidade, newTotal, newProduto }) {
      // Handler do evento @onAddProduto do modal de variação
      this.preco = this.formatNumberToFloat(newPreco);
      this.quantidade = newQuantidade;
      this.total = newTotal;
      
      const descricaoBase = this.produtoSelected?.descricao || newProduto.descricao;
      
      // Constrói a string da combinação a partir do objeto
      if (newProduto?.combinacao) {
        const combinacaoString = [];
        for (const key in newProduto.combinacao) {
          if (key !== 'quantidade' && newProduto.combinacao[key]) {
            combinacaoString.push(newProduto.combinacao[key]);
          }
        }
        
        if (combinacaoString.length > 0) {
          newProduto.descricao = `${descricaoBase} - ${combinacaoString.join('/')}`;
        }
      }
      
      this.addProduto(newProduto);
    },
    onAddProdutoFromLote({ newPreco, newQuantidade, newTotal, newProduto }) {
      // Handler do evento @onAddProduto do modal de lote
      this.preco = this.formatNumberToFloat(newPreco);
      this.quantidade = newQuantidade;
      this.total = newTotal;
      
      const descricaoBase = this.produtoSelected?.descricao || newProduto.descricao;
      
      // Adiciona informações do lote à descrição
      if (newProduto?.lote_baixa) {
        const lote = newProduto.lote_baixa;
        newProduto.descricao = `${descricaoBase} - Nº do Lote: ${lote.numero_lote} / Dt Validade: ${this.formatDate(lote.data_validade)}`;
      }
      
      this.addProduto(newProduto);
    },
    openModalProduto({ product }, currentIndex) {
      this.modalProdutoIsOpen = true;
      this.produtoToEdit = {
        ...product,
        currentIndex,
      };
    },
    handleDeleteProduto(item) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o produto " + item.product.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const aux = this.produtos
              .filter((produto) => produto.currentIndex !== item.currentIndex)
              .map((item, index) => ({
                ...item,
                currentIndex: index,
              }));
            this.form.produtos = [...aux];
            this.produtos = [...aux];
            const subtotal = this.produtos.reduce(
              (acc, produto) =>
                acc + (produto.quantity * produto.price - produto.discount),
              0
            );
            this.form = {
              produtos: [...this.produtos],
              subtotal,
            };
            this.store.formFaturamento.pagamentos = [];
            if (
              this.store.formFaturamento.forma_pagamento.descricao === "Nenhum"
            ) {
              this.store.formFaturamento.pagamentos[0].valor =
                this.store.formImpostos.totalNFE;
            }
          }
        });
    },
    closeModalProduto() {
      this.modalProdutoIsOpen = false;
    },
    setDesconto() {
      if (!this.produtoSelected) return;
      this.form.total =
        this.form.preco * this.form.quantidade - this.form.desconto;
      this.produtoSelected.total =
        parseFloat(this.produtoSelected.preco) *
          parseFloat(this.produtoSelected.quantidade) -
        this.produtoSelected.desconto;
    },
    validateProdutoState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async saveEditProduto(newEditedProduto) {
      if (
        this.reservaCondicionalUltrapassada(
          newEditedProduto,
          newEditedProduto.quantidade,
          this.form.produtos,
          newEditedProduto.currentIndex
        )
      ) {
        return;
      }

      this.form.produtos[newEditedProduto.currentIndex] = {
        ...this.form.produtos[newEditedProduto.currentIndex],
        product: newEditedProduto,
        price: newEditedProduto.preco,
        quantity: newEditedProduto.quantidade,
        totalPrice:
          newEditedProduto.preco * newEditedProduto.quantidade -
          parseFloat(newEditedProduto.desconto),
        discount: parseFloat(newEditedProduto.desconto),
      };
      this.form.subtotal = this.form.produtos.reduce(
        (acc, produto) =>
          acc + produto.price * produto.quantity - produto.discount,
        0
      );
      this.produtos = _.cloneDeep(this.form.produtos);
      this.store.formProduto = _.cloneDeep(this.form);
      this.modalProdutoIsOpen = false;
    },
    onSearchProduto(search, loading) {
      if (search.length > 1 && search[0] === "+") {
        loading(true);
        this.searchKit(loading, search, this);
        return;
      }
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchProdutos(loading, search, this);
      }
    },
    searchProdutos: _.debounce(async (loading, search, vm) => {
      vm.produtosFetched = await vm.fetchProdutos(
        search,
        vm.typeFilter,
        vm.store?.formCliente?.id_pessoa,
        vm.selectedLista
      );
      loading(false);
    }, 350),
    searchKit: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/kit/get-kit", { search });
      vm.produtosFetched = data.map((kit) => ({
        ...kit,
        descricao: kit.nome,
        isKit: true,
      }));
      loading(false);
    }, 350),
    getKitInfo(kitData) {
      const description = kitData.productOfTradeCollection.reduce(
        (acc, produto, index) =>
          acc +
          `${index + 1} - ${produto.product.descricao} - QTD: ${
            produto.product.quantidade
          }<br/>`,
        ""
      );
      return description;
    },
    setProduto(produto) {
      if (!produto) return;
      this.descricao = produto.descricao;

      if (produto?.variavel) {
        this.produtoSelected = produto;
        this.$bvModal.show("variacaoModal");
        return;
      }

      if (produto?.lote) {
        this.estoqueProduto = produto.quantidade;
        const preco_atacado = produto?.preco_atacado ?? 0;
        const qtd_atacado = produto?.quantidade_atacado ?? 0;
        this.quantidade = 1;

        const isAtacadoValue =
          this.quantidade >= qtd_atacado &&
          preco_atacado > 0 &&
          this.store.formCliente.tipo_atacado;

        if (isAtacadoValue) {
          this.preco = parseFloat(preco_atacado);
        } else this.preco = parseFloat(produto.preco);

        if (parseFloat(produto?.preco_lista_cliente ?? 0) > 0) {
          this.preco = parseFloat(produto.preco_lista_cliente);
        }

        this.total = this.quantidade * parseFloat(this.preco);

        this.produtoSelected = {
          ...produto,
          preco: this.preco,
          quantidade: this.quantidade,
          tipo_atacado: isAtacadoValue,
        };
        this.produtoSelected.total = this.total;
        this.produtoSelected.quantidade_original = produto.quantidade;

        this.atualizarLotes++;

        this.$nextTick(() => {
          this.$bvModal.show("loteModal");
        });

        this.produtosFetched = [];
        return;
      }

      if (produto?.isKit) {
        produto.productOfTradeCollection.forEach((product, index) => {
          const produtoToAdd = {
            ...product.product,
            price: product.product.preco,
            quantity: product.product.quantidade,
            totalPrice: product.product.total,
            discount: product.product?.desconto ?? 0,
            active: true,
            currentIndex: index,
          };
          this.addProduto(produtoToAdd, true);
        });
        return;
      }
      this.estoqueProduto = produto.quantidade;
      const preco_atacado = produto?.preco_atacado ?? 0;
      const qtd_atacado = produto?.quantidade_atacado ?? 0;
      this.quantidade = 1;

      const isAtacadoValue =
        this.quantidade >= qtd_atacado &&
        preco_atacado > 0 &&
        this.store.formCliente.tipo_atacado;

      if (isAtacadoValue) {
        this.preco = parseFloat(preco_atacado);
      } else this.preco = parseFloat(produto.preco);

      if (parseFloat(produto?.preco_lista_cliente ?? 0) > 0) {
        this.preco = parseFloat(produto.preco_lista_cliente);
      }

      this.total = this.quantidade * parseFloat(this.preco);

      this.produtoSelected = {
        ...produto,
        preco: this.preco,
        quantidade: this.quantidade,
        tipo_atacado: isAtacadoValue,
      };
      this.produtoSelected.total = this.total;
      this.produtoSelected.quantidade_original = produto.quantidade;

      this.produtoFilled = true;
      this.fromSelect = true;
      this.$nextTick(() => {
        this.$refs.quantidade.$el.focus();
        let inputEl = this.$refs.quantidade.$el;
        setTimeout(() => {
          inputEl.select();
        }, 100);
      });
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { produtos } = this.$route.params.orcamentoData;

      this.produtos = produtos.map((produto) => {
        const produtoFormatted = {
          ...produto.product,
          preco: produto.product.preco,
          quantidade: produto.product.quantidade,
          desconto: produto.product.desconto,
          total: produto.product.total,
        };
        return {
          product: produtoFormatted,
          price: produto.price,
          quantity: produto.quantity,
          totalPrice: produto.totalPrice,
          discount: produto.discount,
          active: produto.active,
          currentIndex: produto.currentIndex,
        };
      });
      const subtotal = this.produtos.reduce(
        (acc, produto) =>
          acc + (produto.quantity * produto.price - produto.discount),
        0
      );
      this.form = {
        produtos: [...this.produtos],
        subtotal,
      };
    } else {
      this.form = new ProdutoData({});
      this.form.produtos = [];
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 1;
    },
  },
};
</script>
